import { render } from "./Business.vue?vue&type=template&id=4092f154&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"

import "./Business.vue?vue&type=style&index=0&id=4092f154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4092f154"]])

export default __exports__